import { CALL_API } from "admin/middlewares/api";

export const TIME_TRAVEL_GET_DATE_REQUEST = "TIME_TRAVEL_GET_DATE_REQUEST";
export const TIME_TRAVEL_GET_DATE_SUCCESS = "TIME_TRAVEL_GET_DATE_SUCCESS";
export const TIME_TRAVEL_GET_DATE_ERROR = "TIME_TRAVEL_GET_DATE_ERROR";

export function get_date() {
  return {
    [CALL_API]: {
      endpoint: "/api/system/get-time",
      authenticatedRequest: true,
      types: [
        TIME_TRAVEL_GET_DATE_REQUEST,
        TIME_TRAVEL_GET_DATE_SUCCESS,
        TIME_TRAVEL_GET_DATE_ERROR,
      ],
    },
  };
}

export const TIME_TRAVEL_SET_DATE_REQUEST = "TIME_TRAVEL_SET_DATE_REQUEST";
export const TIME_TRAVEL_SET_DATE_SUCCESS = "TIME_TRAVEL_SET_DATE_SUCCESS";
export const TIME_TRAVEL_SET_DATE_ERROR = "TIME_TRAVEL_SET_DATE_ERROR";

export function set_date(date) {
  return {
    [CALL_API]: {
      endpoint: "/api/system/set-time/" + date,
      authenticatedRequest: true,
      method: "POST",
      additionalData: date,
      types: [
        TIME_TRAVEL_SET_DATE_REQUEST,
        TIME_TRAVEL_SET_DATE_SUCCESS,
        TIME_TRAVEL_SET_DATE_ERROR,
      ],
    },
  };
}

export const BE_ADMIN_URL_CHANGE = "BE_ADMIN_URL_CHANGE";

export function set_path(path) {
  return { type: BE_ADMIN_URL_CHANGE, path };
}
